module.exports = __webpack_public_path__ + "e96b88d4f33a37d76078b27f2252183e.fbx";